<template>
  <NewDashboard />
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
// import greetingNow from "@/plugins/greeting.js";
import NewDashboard from "../components/NewDashboard/index.vue";
import checkGlobalConfigs from "@/mixins/checkGlobalConfigs";
import { DASHBOARD_EVENT } from "@/config/constants/trackEventIds";

export default {
  name: "Dashboard",
  components: {
    NewDashboard
  },
  mixins: [checkGlobalConfigs()],
  data() {
    return {
      statusType: "",
      statusMessage: "",
      modalCreateActive: false,
      dismissOtherLinked: false,
      holiday: "",
      dismissHoliday: false,
      showPreview: false,
      template_id: "",
      showCreatePage: false,
      showEcom: false
    };
  },
  computed: {
    ...mapGetters("tutorial", {
      sections: "sections"
    }),
    ...mapState({
      shopInfo: state => state.account.shopInfo
    }),
    ...mapState("page", {
      pagesList: "pages",
      templates: "templates"
    }),
    ...mapState("agency", {
      agencyInfo: "info"
    }),
    messageType() {
      // let doneChecklist = false;
      // if (Cookies.get("check-list") == undefined) {
      //   doneChecklist = false;
      // } else {
      //   doneChecklist = true;
      // }
      // let isTrial = this.shopInfo && this.shopInfo.plan == "trial";
      // let hasExpired = this.shopInfo && this.shopInfo.remainingDays <= 0;
      // if (isTrial && hasExpired) return "TrialBlock";
      // let hasExpired =
      //   this.shopInfo &&
      //   this.shopInfo.plan == "trial" &&
      //   this.shopInfo.remainingDays <= 0;
      // if (this.holiday == "Tet" && !this.dismissHoliday && !hasExpired) {
      //   // const _dismissTetBanner = Cookies.get("gfTet2020") == undefined;
      //   return "TetCanhTy";
      // }
      if (this.shopInfo !== undefined) {
        if (this.shopInfo.passwordEnabled) {
          return "EcomSolidAds";
        }
        if (this.shopInfo.plan == "trial") {
          if (this.shopInfo.remainingDays > 5) {
            return "GuideTip";
          } else {
            return "TrialBlock";
          }
        } else if (this.shopInfo.plan == "starter") {
          return "ThankStarter";
        } else if (this.shopInfo.plan == "professional") {
          return "ThankProfessional";
        } else if (this.shopInfo.plan == "advanced") {
          return "ThankAdvanced";
        }
      }
      return "GuideTip";
    },
    dynamicBlock() {
      return () =>
        // eslint-disable-next-line vue/no-async-in-computed-properties
        import("../components").then(res => {
          return res[this.messageType];
        });
    },
    dynamicProps() {
      let props = {};
      if (this.messageType == "TrialBlock") {
        props.shopInfo = this.shopInfo;
      }
      return props;
    },
    accountExpired() {
      return this.shopInfo.plan == "trial" && this.shopInfo.remainingDays <= 0;
    },
    templatesList() {
      let output = [];
      if (this.templates && this.templates.list && this.templates.list.length) {
        let arr = JSON.parse(JSON.stringify(this.templates.list));
        // eslint-disable-next-line no-unused-vars
        arr.sort((a, b) => {
          if (a.status == "new" && b.status != "new") return -1;
          return 0;
        });
        for (let i = 0, len = arr.length; i < len; i++) {
          if (output.length > 3) break;
          // if (arr[i].tags.indexOf("homepages") > -1)
          output.push(arr[i]);
        }
      }
      return output;
    }
  },
  watch: {
    shopInfo: {
      deep: true,
      handler() {
        this.setGreeetingText();
      }
    }
  },
  created() {
    if (localStorage.gfTet2020 == "dismiss") {
      this.dismissHoliday = true;
    }
    this.holiday = "Tet";

    this.trackEvent({ event_id: DASHBOARD_EVENT.VIEWED });
  },
  methods: {
    ...mapActions("page", {
      fetchTemplates: "fetchTemplates"
    }),
    ...mapActions("common", {
      trackEvent: "trackEvent"
    }),
    openModalEcom() {
      this.showEcom = true;
    },
    closeEcom() {
      this.showEcom = false;
    },
    fetCh() {
      this.fetchTemplates({
        shop: this.shopInfo.shopifyDomain,
        tags: "homepages",
        onSuccess: () => {
          // this.fetched = true;
        }
      });
    },
    closePreview() {
      this.showPreview = false;
      this.template_id = null;
    },
    openPreview(id) {
      this.template_id = id;
      this.showPreview = true;
    },
    openCreatePage(id) {
      this.template_id = id;
      this.showCreatePage = true;
    },
    closeCreatePage() {
      this.showCreatePage = false;
      // this.template_id = null;
    },
    setGreeetingText() {
      if (this.shopInfo) {
        // let _greet = greetingNow();
        // let greeting = this.$t(_greet);
        // this.$route.meta.headerTitle = `${greeting}, ${this.shopInfo.firstName} ${this.shopInfo.lastName}`;

        this.$route.meta.headerDomain = this.shopInfo.shopifyDomain;
      }
    },
    goToCreate() {
      if (this.accountExpired) return false;
      this.modalCreateActive = true;
      // this.$router.replace({ name: "LandingPagesTemplate" });
    },
    closeModal() {
      this.modalCreateActive = false;
      // this.$router.replace({ name: "LandingPagesTemplate" });
    },
    dismissOtherAgencyLinked() {
      this.dismissOtherLinked = true;
    },
    dismissDynamicBlock(type) {
      if (type === "tet2020") {
        localStorage.gfTet2020 = "dismiss";
        this.dismissHoliday = true;
      }
    },
    goToCreatePage() {
      this.$router.replace({ name: "HomePagesTemplate" });
    }
  }
};
</script>

<style lang="scss" scoped>
.header-title {
  margin-bottom: 24px;
  .title {
    flex-direction: column;
  }
  .description {
    align-items: flex-end;
    // flex-wrap: nowrap;
    i {
      font-size: 10px;
      font-weight: bold;
    }
    span {
      margin: 0px;
    }
    .btn {
      margin-left: auto;
      padding: 11px 24px 12px 24px;
      white-space: nowrap;
      &-disabled {
        background-color: $textDarkModeLow;
        color: $textDarkModeHigh;
      }
    }
  }
}

header {
  display: flex;

  .domain {
    color: $shade6;
  }

  .searchbox {
    margin-left: auto;
  }
}

// h3 {
//   font-weight: 600;
//   font-size: 20px;
//   line-height: 30px;
// }

.banners {
  // margin-top: 30px;
  display: flex;
  flex-flow: row wrap;

  .sub-banners {
    display: flex;
    flex-direction: column;
    margin-top: 24px;

    // margin-left: 24px;
    // width: calc(32.5% - 12px);
    @media (min-width: 1280px) {
      margin-top: unset;
    }
  }
}

.page-block-list {
  display: flex;
  flex-flow: row wrap;
  margin-left: -24px;
  margin-right: -24px;
  position: relative;

  &.disabled {
    opacity: 0.3;

    &:after {
      position: absolute;
      cursor: default;
      content: "";
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
    }
  }

  // ::v-deep {
  //   .add-page {
  //     // cursor: default;
  //   }
  // }
}

::v-deep .page-block {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border-radius: $radius;
  flex: 1;
  // margin-left: 24px;
  padding: 16px;
  // 228x318
  // min-width: calc(228px);
  min-height: calc(318px);
  // width: calc(25% - 24px);
  // max-width: calc(228px);
  // max-height: calc(318px);
}

::v-deep {
  .page-block,
  .template-item {
    margin-top: 16px;
  }
}

.support-block,
.banner-block {
  flex: 1;
}

.exit-btn {
  // width: 24px;
  position: absolute;
  @include flex-center;
  right: 5.56%;
  top: 8.89%;
  // right: 8px;
  // top: 16px;
  right: 16px;
  top: -100px;
  z-index: 50;
  // padding: 4px;
  font-size: 18px;
  cursor: pointer;
  @include trans-all;
  border-radius: $radius;
  background: $light3;
  &:hover {
    background: $textDarkModeHigh;
  }
}

@media (min-width: 1024px) {
  .exit-btn {
    // top: 16px;
    right: -8px;
  }
}
@media (min-width: 1280px) {
  .exit-btn {
    // top: 50px;
    // right: 40px;
  }
}
@media (min-width: 1440px) {
  .exit-btn {
    // top: 72px;
    // right: 72px;
  }
}

.btn-close-noti {
  @include flex-center;
  padding: 0;
  outline: none;
  border: none;
  padding: 10px;
  margin-top: -8px;
  margin-bottom: -8px;
  margin-right: -8px;
  cursor: pointer;
  color: #ddd;
  i {
    font-weight: bold;
  }
  @include trans-all;
  &:hover {
    color: #fff;
  }
}
</style>
